import { useSidebarUnreadBadgesStore } from 'app/src/shared/sidebar-unread-badges/sidebar-unread-badges.store';

export function refreshSidebarUnreadBadges(): void {
  void useSidebarUnreadBadgesStore().refresh();
}
